import { getCountertopRunIsland } from '../helpers';

import type { Breakpoint } from '../breakpoint.class';
import type { PanelItemGroup } from '../../panel-item-groups/panel-item-group.class';
import type { PanelItemGroups } from '../../panel-item-groups/panel-item-groups.class';

const findNearestGroup = (panelItemGroups: PanelItemGroups, center: number): PanelItemGroup | null => {
	return panelItemGroups.children.reduce((prev: PanelItemGroup | null, current) => {
		const diff = Math.abs(current.center.x - center);
		if (!prev || diff < Math.abs(prev.center.x - center)) return current as PanelItemGroup;
		return prev;
	}, null);
};

/**
 * Moves the breakpoint onto the centre of the appliance column nearest to it.
 * @param breakpoint the breakpoint to move
 */
export const snapToNearestGroupCenterCfn = (breakpoint: Breakpoint): void => {
	const { panel = null, countertop = null } = breakpoint.refMap ?? {};

	// Panel/Backsplash breakpoints take priority (backsplash refMap has panel reference due to inheritance)
	if (panel?.breakpoints?.children?.some((child) => child.id === breakpoint.id)) {
		const group = findNearestGroup(panel.panelItemGroups, breakpoint.center);
		if (group) breakpoint.center = group.center.x;
		return;
	}

	if (!countertop?.breakpoints?.children?.some((child) => child.id === breakpoint.id)) return;

	const frontPanel = getCountertopRunIsland(countertop)?.panels?.getFrontPanel() ?? null;
	if (!frontPanel) return;

	const group = findNearestGroup(frontPanel.panelItemGroups, breakpoint.center);
	if (group) breakpoint.center = group.center.x;
};
